import { dset } from 'dset';

/**
 * @key format - 'a.b.c', 'a.1.c'
 */
export function setByValues<T extends Object>(
  draft: T,
  values: { [key: string]: any },
) {
  Object.entries(values).forEach(([key, value]) => {
    dset(draft, key, value);
  });
}
